/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Address,
  Coordinate,
} from '../models/index';
import {
    AddressFromJSON,
    AddressToJSON,
    CoordinateFromJSON,
    CoordinateToJSON,
} from '../models/index';

export interface AddressFromCoordinateRequest {
    latitude?: number;
    longitude?: number;
}

export interface CoordinateFromAddressRequest {
    street?: string;
    postalcode?: string;
    country?: string;
}

/**
 * 
 */
export class MapsApi extends runtime.BaseAPI {

    /**
     */
    async addressFromCoordinateRaw(requestParameters: AddressFromCoordinateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Address>> {
        const queryParameters: any = {};

        if (requestParameters.latitude !== undefined) {
            queryParameters['latitude'] = requestParameters.latitude;
        }

        if (requestParameters.longitude !== undefined) {
            queryParameters['longitude'] = requestParameters.longitude;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/Maps/AddressFromCoordinate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddressFromJSON(jsonValue));
    }

    /**
     */
    async addressFromCoordinate(requestParameters: AddressFromCoordinateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Address> {
        const response = await this.addressFromCoordinateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async coordinateFromAddressRaw(requestParameters: CoordinateFromAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Coordinate>> {
        const queryParameters: any = {};

        if (requestParameters.street !== undefined) {
            queryParameters['street'] = requestParameters.street;
        }

        if (requestParameters.postalcode !== undefined) {
            queryParameters['postalcode'] = requestParameters.postalcode;
        }

        if (requestParameters.country !== undefined) {
            queryParameters['country'] = requestParameters.country;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/Maps/CoordinateFromAddress`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CoordinateFromJSON(jsonValue));
    }

    /**
     */
    async coordinateFromAddress(requestParameters: CoordinateFromAddressRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Coordinate> {
        const response = await this.coordinateFromAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
